import gsap from 'gsap';

import AssetsLoader from './loader/assets';
import Stage from './_stage';


export default class CharaSlider{

    constructor(){

        // three.js
        this.loader = null;
        this.stage = null;
        this.textures = {};
        this.$target = document.querySelector('.js-slide-targets');
        this.$slide = document.querySelector('.js-slide-content');
        this.$imgs = [...this.$target.querySelectorAll('img')];

        // swipe
        this.startX = 0;
        this.endX = 0;
        this.startY = 0;
        this.endY = 0;
        this.isDragging = false;

        // slide
        this.slideupTimer = -1;

        this._init();
    }


    _init(){
        this.loader = new AssetsLoader();
        this.loader.load(this._getImgs(), this._start.bind(this));
    }


    _getImgs(){
        const sources = [];
        sources.push({'key':'noise', src:this.$target.getAttribute('data-noise')});

        this.$imgs.forEach($elem => {
            const _key = $elem.getAttribute('data-key');
            const _src = $elem.getAttribute('src');
            sources.push({key:_key, src:_src});
        });

        return sources;
    }


    _start(){
        this.stage = new Stage(this.loader._textures);

        this._resize();
        window.addEventListener('resize', this._resize.bind(this));

        this._swipeAction();
        this._ui();
    }


    _resize(){
        if(this.stage) this.stage.resize();
    }


    _swipeAction(){

        if('ontouchstart' in window){
            this.$slide.addEventListener('touchstart', this._startAction.bind(this));
            this.$slide.addEventListener('touchmove', this._moveAction.bind(this));
            this.$slide.addEventListener('touchend', this._endAction.bind(this));
        }
        else{
            this.$slide.addEventListener('mousedown', this._startAction.bind(this));
            this.$slide.addEventListener('mousemove', this._moveAction.bind(this));
            this.$slide.addEventListener('mouseup', this._endAction.bind(this));
        }
    }

    _startAction(e){
        this.isDragging = true;
        this.startX = e.touches ? e.touches[0].clientX : e.clientX;
        this.startY = e.touches ? e.touches[0].clientY : e.clientY;
    }

    _moveAction(e) {
        if(!this.isDragging) return;
        this.endX = e.touches ? e.touches[0].clientX : e.clientX;
        this.endY = e.touches ? e.touches[0].clientY : e.clientY;

        if(Math.abs(this.endX - this.startX) > Math.abs(this.endY - this.startY)){
            e.preventDefault();
        }
    }

    _endAction(){
        if(!this.isDragging) return;

        const distance = this.endX - this.startX;
        console.log(this.startX, this.endX)
        if(Math.abs(distance) > 100){
            if(distance > 0) this.stage.swipeAction('prev');
            else this.stage.swipeAction('right');
        }

        this.isDragging = false;
        this.startX = 0;
        this.endX = 0;
        this.startY = 0;
        this.endY = 0;
    }


    _ui(){
        
        document.querySelector('.js-slide-prev').addEventListener('click', ()=>{
            this._sccrollUp();

            clearTimeout(this.slideupTimer);
            this.slideupTimer = setTimeout(()=>{
                this.stage.swipeAction('prev');
            }, 400);
        });

        document.querySelector('.js-slide-next').addEventListener('click', ()=>{
            this._sccrollUp();

            clearTimeout(this.slideupTimer);
            this.slideupTimer = setTimeout(()=>{
                this.stage.swipeAction('right');
            }, 400);
        });
        
        [...document.querySelectorAll('.js-slide-change')].forEach(($item, index) =>{

            $item.addEventListener('click', ()=>{
                this._sccrollUp();

                clearTimeout(this.slideupTimer);
                this.slideupTimer = setTimeout(()=>{
                    this.stage.change(index+1);
                }, 400);
            });
        });
    }


    _sccrollUp(callback=null){
        const $target = document.querySelector('.js-slide');
        let targetPos = parseInt($target.getBoundingClientRect().top) + parseInt(window.pageYOffset);

        gsap.to([document.querySelector("html"), document.querySelector("body")], { 
            duration: 0.7, scrollTop: targetPos, 
            ease: "power2.out" ,
            onComplete: ()=>{
                if(callback) callback();
            }
        });
    }
}